/** Валидация для email */
export const emailValidator = (inputValue: string): boolean => {
  const regular = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;
  return regular.test(inputValue);
};

/** Валидация логина и пароля (от 1 символа) */
export const validator = (inputValue: string): boolean => {
  const regular = /[0-9а-яА-яa-zA-Z!@#$%^&*]{1,}/;
  return regular.test(inputValue);
};

/** Валидация url */
export const urlValidator = (inputValue: string): boolean => {
  const regular = /(^(ftp|http|https)::\/\/)?[a-z0-9~_\-.]+\.[a-z]{2,9}/i;
  return regular.test(inputValue);
};

/** Валидация размера текста в 255 знаков * */
export const textLengthValidator = (inputValue: string, maxLength?: number): boolean => {
  return inputValue.length <= (maxLength ?? 255);
};

/**  функция, которая принимает колбеки в зависимости от типа валидации, которая необходима, поля, которым нужно
присвоить значения. Используется для изменения цвета инпута при изменении в нем(валидация успешная или нет)
@param value - строка, которая приходит на валидацию
@param setValueCallback - колбек, который записывает в useState текущее значение инпута
@param validationCallback - колбек с типом валидации, используем спец. функцию из Validation.ts
@param setValidationCallback - колбек, который записывает в useState буленовское значение, есть ли ошибка в
данном инпуте или нет
*/
export const onChangeWithValidation = (
  value: string,
  setValueCallback: (val: string) => void,
  validationCallback: (val: string) => boolean,
  setValidationCallback: (val: boolean) => void,
) => {
  setValueCallback(value);
  setValidationCallback(!validationCallback(value));
};
